var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.locationTime))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.location.data.address))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }